<template>
	<div>
		<v-container>
			<v-layout>
				<v-flex xs5 d-flex justify-start mr-3>
					<select-date
						placeholder="Fecha de inicio"
						icon="event"
						v-model="params.dateInit"
						@input="loadData"
					/>
					<select-date
						placeholder="Fecha de fin"
						v-model="params.dateEnd"
						@input="loadData"
					/>
				</v-flex>
				<v-flex xs2>
					<select-button
						placeholder="Acción"
						:items="actions"
					/>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex>
					<table-run
						:columns="columns"
						:rows="rows"
						:include-delete="false"
						:include-export-to-excel="false"
					>
						<template slot="rows" scope="props">
							<td>{{ props.row.date }}</td>
							<td>{{ props.row.hour }}</td>
							<td>{{ props.row.device }}</td>
							<td>{{ props.row.ip }}</td>
							<td>{{ props.row.action }}</td>
							<td>{{ props.row.activity }}</td>
						</template>
					</table-run>
					<div class="text-xs-right mt-3">
						<v-pagination
							:length="totalPages"
							v-model="params.page"
							:total-visible="pagesVisible"
							@input="loadData"
							></v-pagination>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
import TableRun from 'table-run';
import selectDate from '@/clerkinn/shared/select-date';
import selectButton from '@/clerkinn/shared/select-button';

function loadData() {}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function data() {
	return {
		actions: [],
		activeTab: 'tab-1',
		columns: [
			{ id: 1, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } },
			{ id: 2, name: 'Hora', code: 'hour', isSortable: { down: true, up: false } },
			{ id: 3, name: 'Dispositivo', code: 'device', isSortable: { down: true, up: false } },
			{ id: 4, name: 'Dirección IP', code: 'ip', isSortable: { down: true, up: false } },
			{ id: 5, name: 'Acción', code: 'action', isSortable: { down: true, up: false } },
			{ id: 6, name: 'Actividad', code: 'activity', isSortable: { down: true, up: false } },
		],
		params: {
			dateEnd: '',
			dateInit: '',
			page: 1,
			perPage: 20,
			search: null,
			flagActive: null,
		},
		rows: [
			{
				date: '2018/10/16',
				hour: '14:22',
				device: 'Mackbook Pro',
				ip: '192.168.0.5',
				action: 'Crear',
				activity: 'Reserva 28/05',
			},
		],
		totalPages: null,
	};
}

export default {
	name: 'activity-list',
	components: {
		TableRun,
		selectButton,
		selectDate,
	},
	computed: {
		pagesVisible,
	},
	data,
	methods: {
		loadData,
	},
};
</script>




// WEBPACK FOOTER //
// ActivityList.vue?68f42328